import { ssm_getcookie } from "../../common/utils/ssm_util";
import { fetchAPI } from "../config";

export async function registerNode(node) {
  let jsonstr = JSON.stringify(node);
  let sid = ssm_getcookie("ssm_sid");
  const para = { jsonstr, sid };
  const data = await fetchAPI("/ssm_api_node/registernode", para);
  return data;
}
